module.exports = __webpack_public_path__ + "static/media/panton-regular-italic.f7c8e875.otf";